import getParameterFromErrorResponse from '@/services/general/validation/parameterFromErrorResponse';

export default function validationIndexationCommande(response, messages) {
  if (!response?.data?.error?.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('COMMANDE_INDEXATION_HAS_ECHENACIERS_GROUPES') === 0) {
      if (getParameterFromErrorResponse(message)[0]?.split(',')?.length > 1) {
        messages.push({
          message: 'validationCommande.indexation.commandesIndexationHasEcheancierGroupe',
          parametres: { codes: getParameterFromErrorResponse(message)[0] },
        });
      } else {
        messages.push({
          message: 'validationCommande.indexation.commandeIndexationHasEcheancierGroupe',
          parametres: { code: getParameterFromErrorResponse(message)[0] },
        });
      }
    }
    if (message.indexOf('COMMANDE_INDEXATION_NOT_BEEN') === 0) {
      messages.push({ message: 'validationCommande.indexation.commandeIndexationNotBeenIndex' });
    }
    if (message.indexOf('COMMANDE_INDEXATION_TYPES_PRODUITS_NOT_EXIST') === 0) {
      messages.push({ message: 'validationCommande.indexation.commandeIndexationTypesProduitsNotExist' });
    }
    if (message.indexOf('COMMANDE_INDEXATION_FACTUREE') === 0) {
      if (getParameterFromErrorResponse(message)[0]?.split(',')?.length > 1) {
        messages.push({
          message: 'validationCommande.indexation.commandesIndexationFacturee',
          parametres: { codes: getParameterFromErrorResponse(message)[0] },
        });
      } else {
        messages.push({
          message: 'validationCommande.indexation.commandeIndexationFacturee',
          parametres: { code: getParameterFromErrorResponse(message)[0] },
        });
      }
    }
    if (message.indexOf('COMMANDE_INDEXATION_HAS_NOT_RESET') === 0) {
      if (getParameterFromErrorResponse(message)[0]?.split(',')?.length > 1) {
        messages.push({
          message: 'validationCommande.indexation.commandesIndexationCantReset',
          parametres: { codes: getParameterFromErrorResponse(message)[0] },
        });
      } else {
        messages.push({
          message: 'validationCommande.indexation.commandeIndexationCantReset',
          parametres: { code: getParameterFromErrorResponse(message)[0] },
        });
      }
    }
  });
}
